import { createClient } from '@lumi.new/sdk'
import { createDemoClient, getDemoRole } from './demo'

const demoRole = getDemoRole()
export const isDemoMode = demoRole !== null
// A construção do cliente real não ocorre em modo demo; seus tokens não são usados.
export const lumi = demoRole
  ? createDemoClient(demoRole, window.sessionStorage) as unknown as ReturnType<typeof createClient>
  : createClient({
      projectId: 'p429616054542557184',
      apiBaseUrl: 'https://api.lumi.new',
      authOrigin: 'https://auth.lumi.new',
    })
